// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"e29dbb14","385":"ab7d6f3d","654":"396b4ff4","672":"7e81b5fe","712":"c203fe7f","853":"1909febc","920":"33a4ee80"}[chunkId] + ".chunk.js";
};